<template>
    <div>
        <div v-show="isShow">
            <van-swipe :autoplay="3000" :show-indicators="false">
                <van-swipe-item v-for="(images, index) in images" :key="index">
                    <div @click="productDetails(images)" class="images">
                        <img v-lazy="images.image" style="width:100%" />
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="content" >
                <van-tabs v-model="tabActive" title-active-color="#F34740" title-inactive-color="#333" line-width="30" class="tabs" sticky>
                    <van-tab :title="tabList[0].tabName">
                        <div v-for="(item,index) of list1" :key="index">
                            <cell-list :productInfo="item"></cell-list>
                        </div> 
                    </van-tab>
                    <van-tab :title="tabList[1].tabName">
                        <div v-for="(item,index) of list2" :key="index">
                            <cell-list :productInfo="item"></cell-list>
                        </div> 
                    </van-tab>
                </van-tabs>
                <div class="more red" @click="more">查看全部</div>
            </div>
            <div class='jishu'><i></i><a href="tel:02988852911" >技术支持：西安力邦睿特信息技术有限公司</a><i></i></div>
            <tabbar :active="active"></tabbar>
        </div>
    </div>
</template>

<script>
// import https from '@/https.js'
import tabbar from "@/components/tabbar"
import cellList from "@/components/cellList"
import { Toast } from 'vant'
import {wxLogin} from '@/utils/util'
export default {
    data() {
        return {
            tabActive:0,
            active:"index",
            images: [],
            list1: [],
            list2: [],
            isShow:false,
            tabList:[{tabId:1,tabName:"热销产品"},{tabId:2,tabName:"备案中"}],
        };
    },
    created(){
        document.title="关爱保险商城";
        this.getBanner();
        this.getList(1);//热销产品
         this.getList(2);//备案中
        this.isShow=true;
    //    console.log("index.vue",this.$store.state.userInfo,this.$store.state.token)
    },
    mounted(){

    },
    methods: {
        getList(e){
            let obj={}
            if(e==1){
                obj={"is_hot":"1","is_report":"1"}
            }else{
                 obj={"is_report":"0"}
            }
            this.$https.fetchPost("Goods/index",obj,{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                if(result.data.code==1){
                    this["list"+e]=result.data.data;
                    console.log(this.list1)
                    console.log(this.list2)
                }else if(result.data.code==10001){  //有token,用户未登陆情况
                    this.$store.commit("LOGOUT")
                    this.$router.push("/login")
                }else{
                    Toast(data.msg)
                }
            })
        },
        more(){
           this.$router.push({path:'productList'});
            // console.log("跳转到产品库")
        },
        getBanner(){
            this.$https.fetchPost("Slides/index",{},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                if(result.data.code==1){
                    this.images=result.data.data;
                    // console.log(result.data)
                }else{
                    Toast(data.msg);
                }
            })
        },
        //点击banner跳转到内部或外部链接
        productDetails(items){
            if(items.url!=0){
               this.$router.push("/productDetails?id="+items.id)
            }else{
                window.open(items.url_out);
            }
        }
    },
    components:{
        tabbar,
        cellList,
    },
    computed:{
    }
}
</script>

<style scoped>
  .jishu{
    text-align:center;
    padding:30px 0 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .jishu i{
      width:50px;
      height:2px;
      background-color:#eee;
      display:inline-block;
      margin:0 10px;
      vertical-align:baseline;
  }
  .jishu a{
      text-decoration:none;
      color:#666;
      font-size:12px;
      -webkit-tap-highlight-color:transparent;
  }
  .content{
    padding:0;
    text-align: start;
  }
  .content .tabs  /deep/ .van-tab__text{
      font-size:14px;
      font-weight:500;
  }
  .content /deep/ .van-tabs__content>div div:first-child .van-card{
      margin-top:3.5px;
  }
.content /deep/ .van-tabs__content>div div:last-child .van-card{
      margin-bottom:0px;
  }
  .images{
      max-height: 200px;
  }
  .more{
      text-align: center;
      height:50px ;
      line-height: 50px;
      
  }
  .content /deep/ .van-tabs__line{
    bottom: 0.46rem;
    height: 3px;
    background: linear-gradient(-270deg,rgba(243,71,64,1),rgba(254,142,137,1));
    border-radius:2PX;
  }
  .content  /deep/ .van-tabs__nav {
        background: #f5f5f5;
    }
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue